module.exports = __webpack_public_path__ + "static/media/ic-medicine-helicopter.d1efa452.svg";